"use client";
import { createContext, useContext } from "react";
export type ConsoleScreen =
  | "search"
  | "projects"
  | "project"
  | "about"
  | "contact"
  | "theme"
  | "resume"
  | "help"
  | "coffee"
  | "notebook";
export const ConsoleContext = createContext({
  openConsole: (_screen: ConsoleScreen = "search") => {},
  coffeeLifted: false,
  toggleCoffee: () => {},
});
export const usePortfolioConsole = () => useContext(ConsoleContext);
